module.exports = __webpack_public_path__ + "img/icon-coin.d477724b.png";